import { IApplicationState } from '../../types/redux';

export function selectResetPassword(state: IApplicationState) {
  return state.resetPassword;
}
